import React, { useCallback, useMemo, useState } from 'react';
import { Tappable } from '@vectord/components';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';

import { ACADEMY_TOPIC_TYPES } from 'data/academyTopicTypes';
import { useAttachAcademyTopicsMutation } from 'features/classCreation';
import Field from 'components/Field';
import AcademyTopicSelect from 'components/AcademyTopicSelect';

function CreateLibraryClasses({ library }) {
  const [classes, setClasses] = useState([]);
  const [attachAcademyTopics, { isLoading: isUpdating }] =
    useAttachAcademyTopicsMutation();

  const attachedAcademyTopicIds = useMemo(
    () => library.library_academy_topics.map((o) => o.academy_topic.id),
    [library]
  );

  const handleAdd = useCallback(async () => {
    if (isUpdating) {
      return;
    }

    if (classes.length === 0) {
      cogoToast.warn('Please select atleast 1 class.');
      return;
    }

    const response = await attachAcademyTopics({
      id: library.id,
      academyTopicIds: classes.map((o) => o.value),
    });
    if (response.error) {
      cogoToast.error(
        response.error?.data?.message ||
          'Failed to add classes, try again after sometime.'
      );
    } else {
      cogoToast.success('Selected classes have been added to the library.');
      setClasses([]);
    }
  }, [attachAcademyTopics, classes, isUpdating, library.id]);

  return (
    <Field label="Classes">
      <AcademyTopicSelect
        isMulti
        className="m-b-xs"
        closeMenuOnSelect={false}
        excludedAcademyTopicIds={attachedAcademyTopicIds}
        isDisabled={isUpdating}
        onChange={setClasses}
        type={ACADEMY_TOPIC_TYPES.template}
        value={classes}
      />
      <Tappable
        className="btn btn-primary btn-outlined btn-long"
        disabled={isUpdating}
        onClick={handleAdd}
      >
        Add Selected Classes
      </Tappable>
    </Field>
  );
}

CreateLibraryClasses.propTypes = {
  library: PropTypes.object.isRequired,
};

export default CreateLibraryClasses;
